import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BASE_PATH } from '../purchase-service/variables';
import {
  PageInfoSalesRequestResultDTO,
  SalesRequestDTO,
  SalesRequestFilter,
  SalesRequestResultDTO,
  SalesRequestStatus,
  SalesRequestUpdateDTO,
} from './models';

/** `SalesRequestController` — `/v1/sales-request`. */
@Injectable({ providedIn: 'root' })
export class SalesRequestApiService {
  private readonly http = inject(HttpClient);
  private readonly basePath = inject(BASE_PATH);

  private get url(): string {
    return `${this.basePath}/v1/sales-request`;
  }

  page(filter: SalesRequestFilter): Observable<PageInfoSalesRequestResultDTO> {
    let params = new HttpParams();
    Object.entries(filter).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params = params.set(key, String(value));
      }
    });
    return this.http.get<PageInfoSalesRequestResultDTO>(this.url, { params });
  }

  getDetail(id: number): Observable<SalesRequestResultDTO> {
    return this.http.get<SalesRequestResultDTO>(`${this.url}/${id}`);
  }

  create(body: SalesRequestDTO): Observable<SalesRequestResultDTO> {
    return this.http.post<SalesRequestResultDTO>(this.url, body);
  }

  update(
    id: number,
    body: SalesRequestUpdateDTO,
  ): Observable<SalesRequestResultDTO> {
    return this.http.put<SalesRequestResultDTO>(`${this.url}/${id}`, body);
  }

  /** APPROVED / REJECTED. */
  updateStatus(
    id: number,
    status: SalesRequestStatus,
  ): Observable<SalesRequestResultDTO> {
    return this.http.put<SalesRequestResultDTO>(
      `${this.url}/${id}/status`,
      null,
      { params: new HttpParams().set('status', status) },
    );
  }

  delete(id: number): Observable<SalesRequestResultDTO> {
    return this.http.delete<SalesRequestResultDTO>(`${this.url}/${id}`);
  }

  deleteItems(
    id: number,
    itemIds: number[],
  ): Observable<SalesRequestResultDTO> {
    return this.http.delete<SalesRequestResultDTO>(
      `${this.url}/${id}/sales-request-item`,
      { params: new HttpParams().set('itemIds', itemIds.join(',')) },
    );
  }
}
